// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOMEPAGE_BLOG_PHOTOS = "Fotky z blogov";
export const PHOTOS_SHOW_MORE = "Viac z blogov...";
